import styled, { keyframes } from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import { BaseProductName } from '../../styles';
import PriceNotice from '../price-notice';
import StockStatusColumnComponent from '../stock-status-column';

export const StockStatus = styled.div`
  color: ${p => p.theme.text.quaternary};
  font-size: 0.8rem;
  margin: 0 0.2em;
`;

export const ProductName = BaseProductName;

export const StockStatusColumn = styled(StockStatusColumnComponent)`
  display: flex;
`;

export const PriceAndStockWrapper = styled.div`
  ${media.smallOnly`
    display: grid;
    grid-template-columns: 40px 1fr;
    align-items: baseline;
  `}

  ${media.mediumUp`
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  `}
`;

export const PriceNoticeLabel = styled(PriceNotice)`
  font-size: ${layout.measurements.fontSizeSmall};
  white-space: nowrap;
  font-style: italic;
  margin-bottom: 2px;
`;

export const StockStatusColumnWrapper = styled.div``;

export const PriceColumnWrapper = styled.div`
  display: flex;
  width: auto;
  height: auto;
  flex-direction: column;
  align-items: flex-end;
`;

export const Options = styled.div`
  display: flex;
  align-items: center;
  flex-flow: column;
  transition: opacity ease 0.25s;
`;

export const OptionsButton = styled.button`
  width: 28px;
  height: 28px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Option = styled.button`
  width: 100%;
  white-space: nowrap;
  cursor: pointer;
  padding: ${layout.spacing.xSmall};

  &:hover {
    background: ${p => p.theme.dropdowns.secondary.hoverBackground};
  }
`;

export const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

export const ReportOverlay = styled.div`
  color: ${p => p.theme.text.secondary};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 250ms ease-in-out 1;
`;
